import {
    Badge,
    Box,
    Button,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerFooter,
    DrawerOverlay,
    Flex,
    FormControl,
    FormLabel,
    GridItem,
    Icon,
    Input,
    InputGroup,
    InputRightElement,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Select,
    SimpleGrid,
    Table,
    Tag,
    TagCloseButton,
    TagLabel,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast,
} from "@chakra-ui/react";
import ApiKeysApi from "Api/ApiKeysApi";
import { Field, Form, Formik } from "formik";
import moment from "moment";
import 'moment/locale/pt-br';
import { useLoading } from "Providers/LoadingProvider";
import { useCallback, useEffect, useRef, useState } from "react";
import { FaBook, FaCopy, FaEdit, FaEye, FaEyeSlash, FaKey, FaPlus, FaRedo, FaSearch, FaTrash } from "react-icons/fa";
import { TbKey } from "react-icons/tb";
import { Pagination } from "react-laravel-paginex";

function ApiKeys() {
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState("");
    const [data, setData] = useState({});
    const [currentKey, setCurrentKey] = useState({});
    const loading = useLoading();
    const formDrawer = useDisclosure();

    const getData = async (param) => {
        loading.show();
        let currentPage = param ? param.page : page || 1;
        setPage(currentPage);
        let response = await ApiKeysApi.list(currentPage, filter);
        setData(response.json);
        loading.hide();
    };

    useEffect(() => {
        getData();
    }, [filter]);

    const onFilterSubmit = (formData) => {
        setPage(1);
        setFilter(formData.filter);
    };

    const cardBg = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("gray.200", "gray.700");

    return (
        <>
            <Box bg={cardBg} borderRadius="xl" overflow="hidden" boxShadow="md" border="1px solid" borderColor={borderColor}>
                <Box bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)" py={5} px={6}>
                    <Flex align="center" justify="space-between">
                        <Flex align="center" gap={3}>
                            <Flex align="center" justify="center" bg="whiteAlpha.200" borderRadius="lg" p={2}>
                                <Icon as={TbKey} color="white" boxSize={5} />
                            </Flex>
                            <Box>
                                <Text color="white" fontWeight="bold" fontSize="xl">Chaves de API</Text>
                                <Text color="whiteAlpha.800" fontSize="sm">Gerenciamento de integrações</Text>
                            </Box>
                        </Flex>
                        <Flex gap={2}>
                            <Button
                                colorScheme="whiteAlpha"
                                variant="outline"
                                size="sm"
                                leftIcon={<FaBook />}
                                as="a"
                                href="/integrations/documentation"
                                target="_blank"
                            >
                                Documentação
                            </Button>
                            <Button
                                colorScheme="whiteAlpha"
                                size="sm"
                                leftIcon={<FaPlus />}
                                onClick={() => {
                                    setCurrentKey({});
                                    formDrawer.onOpen();
                                }}
                            >
                                Nova Chave
                            </Button>
                        </Flex>
                    </Flex>
                </Box>
                <Box p={6}>
                    <Flex direction="column" w="100%">
                        <Flex direction="column" w="100%" overflowX="auto" mb={4}>
                            <Formik onSubmit={onFilterSubmit} initialValues={{ filter: "" }}>
                                <Form id="filterForm">
                                    <Field name="filter">
                                        {({ field }) => (
                                            <FormControl>
                                                <SimpleGrid columns={12}>
                                                    <GridItem colSpan={{ base: 12, md: 10 }}>
                                                        <Input
                                                            {...field}
                                                            mb={{ base: 2, md: 0 }}
                                                            borderRightRadius={{ base: 10, md: 0 }}
                                                            placeholder="Pesquisar por nome..."
                                                            borderRadius="10px"
                                                            fontSize="sm"
                                                            size="md"
                                                        />
                                                    </GridItem>
                                                    <GridItem colSpan={{ base: 12, md: 2 }}>
                                                        <Button
                                                            colorScheme="green"
                                                            size="md"
                                                            borderLeftRadius={{ base: 15, md: 0 }}
                                                            type="submit"
                                                            w="100%"
                                                            leftIcon={<FaSearch />}
                                                        >
                                                            Buscar
                                                        </Button>
                                                    </GridItem>
                                                </SimpleGrid>
                                            </FormControl>
                                        )}
                                    </Field>
                                </Form>
                            </Formik>
                        </Flex>
                        <Flex direction="column" w="100%" overflowX="auto">
                            <Table size="sm">
                                <Thead>
                                    <Tr>
                                        <Th>Nome</Th>
                                        <Th>Estações</Th>
                                        <Th>Último Uso</Th>
                                        <Th>Criado em</Th>
                                        <Th textAlign="center">Ações</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {data.data && data.data.length ? (
                                        data.data.map((apiKey) => (
                                            <ApiKeyRow
                                                key={apiKey.id}
                                                apiKey={apiKey}
                                                getData={getData}
                                                onEdit={() => {
                                                    setCurrentKey(apiKey);
                                                    formDrawer.onOpen();
                                                }}
                                            />
                                        ))
                                    ) : (
                                        <Tr>
                                            <Td colSpan={5} textAlign="center" color="gray.500">
                                                Nenhuma chave de API encontrada
                                            </Td>
                                        </Tr>
                                    )}
                                </Tbody>
                            </Table>
                        </Flex>
                        <Flex direction="column" w="100%">
                            <Pagination
                                changePage={getData}
                                data={data}
                                nextButtonText="Próxima"
                                prevButtonText="Anterior"
                            />
                            <Flex w="100%" justify="center" fontSize="sm" color="gray.500">
                                {data?.meta?.total ? (
                                    <Text>
                                        Mostrando de {data.meta.from} a {data.meta.to} de {data.meta.total} registros
                                    </Text>
                                ) : ""}
                            </Flex>
                        </Flex>
                    </Flex>
                </Box>
            </Box>

            <ApiKeyFormDrawer
                apiKey={currentKey}
                isOpen={formDrawer.isOpen}
                onClose={formDrawer.onClose}
                getData={getData}
            />

        </>
    );
}

function ApiKeyRow({ apiKey, getData, onEdit }) {
    const toast = useToast({ position: "top-right" });
    const loading = useLoading();
    const tokenModal = useDisclosure();
    const [showToken, setShowToken] = useState(false);

    const copyToken = () => {
        navigator.clipboard.writeText(apiKey.token);
        toast({
            status: "success",
            title: "Token copiado para a área de transferência!",
            duration: 3000,
            variant: "solid",
            isClosable: true,
        });
    };

    const regenerateToken = async () => {
        const confirmed = window.confirm(
            "Tem certeza que deseja regenerar o token da chave \"" + apiKey.name + "\"?\n\n" +
            "O token atual será permanentemente invalidado e um novo será gerado. " +
            "Todas as integrações que usam o token atual deixarão de funcionar até que sejam atualizadas com o novo token."
        );
        if (!confirmed) return;
        loading.show();
        let response = await ApiKeysApi.regenerateToken(apiKey.id);
        loading.hide();
        if (response.status === 200) {
            toast({
                status: "success",
                title: "Token regenerado com sucesso!",
                duration: 3000,
                variant: "solid",
                isClosable: true,
            });
            getData();
        } else {
            toast({
                status: "error",
                title: "Erro ao regenerar token!",
                duration: 3000,
                variant: "solid",
                isClosable: true,
            });
        }
    };

    const deleteKey = async () => {
        const confirmed = window.confirm(
            "Tem certeza que deseja excluir a chave \"" + apiKey.name + "\"?\n\n" +
            "Esta ação é irreversível. Todas as integrações que usam este token deixarão de funcionar permanentemente."
        );
        if (!confirmed) return;
        loading.show();
        let response = await ApiKeysApi.delete(apiKey.id);
        loading.hide();
        if (response.status === 204) {
            toast({
                status: "success",
                title: "Chave de API excluída com sucesso!",
                duration: 3000,
                variant: "solid",
                isClosable: true,
            });
            getData();
        } else {
            toast({
                status: "error",
                title: "Houve um problema ao excluir a chave! Cód. " + response.status,
                duration: 3000,
                variant: "solid",
                isClosable: true,
            });
        }
    };

    return (
        <>
            <Tr>
                <Td fontWeight="semibold">{apiKey.name}</Td>
                <Td>
                    {apiKey.all_stations ? (
                        <Badge colorScheme="green">Todas</Badge>
                    ) : (
                        <Badge colorScheme="blue">{apiKey.stations?.length || 0} estações</Badge>
                    )}
                </Td>
                <Td>
                    {apiKey.last_used_at
                        ? moment(apiKey.last_used_at).locale('pt-br').fromNow()
                        : <Text color="gray.500" fontSize="xs">Nunca</Text>
                    }
                </Td>
                <Td>{moment(apiKey.created_at).locale('pt-br').format("DD/MM/YYYY")}</Td>
                <Td textAlign="center">
                    <Button
                        colorScheme="green"
                        variant="solid"
                        size="sm"
                        onClick={() => { setShowToken(false); tokenModal.onOpen(); }}
                        leftIcon={<FaKey />}
                        m={1}
                    >
                        Token
                    </Button>
                    <Button
                        colorScheme="blue"
                        variant="solid"
                        size="sm"
                        onClick={onEdit}
                        leftIcon={<FaEdit />}
                        m={1}
                    >
                        Editar
                    </Button>
                    <Button
                        colorScheme="red"
                        variant="solid"
                        size="sm"
                        onClick={deleteKey}
                        leftIcon={<FaTrash />}
                        m={1}
                    >
                        Excluir
                    </Button>
                </Td>
            </Tr>

            <TokenModal
                isOpen={tokenModal.isOpen}
                onClose={tokenModal.onClose}
                token={apiKey.token}
                name={apiKey.name}
                showToken={showToken}
                setShowToken={setShowToken}
                onCopy={copyToken}
                onRegenerate={regenerateToken}
            />
        </>
    );
}

function TokenModal({ isOpen, onClose, token, name, showToken, setShowToken, onCopy, onRegenerate }) {
    const modalBg = useColorModeValue("white", "gray.800");
    const tokenBg = useColorModeValue("gray.50", "gray.600");

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
            <ModalOverlay backdropFilter="blur(4px)" />
            <ModalContent bg={modalBg}>
                <ModalHeader>Token - {name}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <InputGroup size="md">
                        <Input
                            pr="3rem"
                            type={showToken ? "text" : "password"}
                            value={token || ""}
                            isReadOnly
                            fontFamily="mono"
                            fontSize="sm"
                            bg={tokenBg}
                        />
                        <InputRightElement width="3rem">
                            <Button
                                h="1.75rem"
                                size="sm"
                                variant="ghost"
                                onClick={() => setShowToken(!showToken)}
                            >
                                <Icon as={showToken ? FaEyeSlash : FaEye} />
                            </Button>
                        </InputRightElement>
                    </InputGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        colorScheme="orange"
                        variant="solid"
                        size="sm"
                        onClick={() => { onClose(); onRegenerate(); }}
                        leftIcon={<FaRedo />}
                        mr="auto"
                    >
                        Gerar Novo Token
                    </Button>
                    <Button
                        colorScheme="blue"
                        variant="solid"
                        size="sm"
                        onClick={onCopy}
                        leftIcon={<FaCopy />}
                    >
                        Copiar
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

function ApiKeyFormDrawer({ isOpen, onClose, apiKey, getData }) {
    const loading = useLoading();
    const toast = useToast({ position: "top-right" });
    const drawerBgColor = useColorModeValue("white", "gray.700");
    const searchBorderColor = useColorModeValue("gray.200", "gray.600");
    const searchHoverBg = useColorModeValue("gray.50", "gray.600");
    const searchItemBorder = useColorModeValue("gray.100", "gray.600");
    const isEditing = !!apiKey?.id;

    const [selectedStations, setSelectedStations] = useState([]);
    const [stationSearchResults, setStationSearchResults] = useState([]);
    const [stationSearchQuery, setStationSearchQuery] = useState("");
    const searchTimeout = useRef(null);

    useEffect(() => {
        if (isOpen && apiKey?.stations) {
            setSelectedStations(apiKey.stations || []);
        } else if (isOpen) {
            setSelectedStations([]);
        }
        setStationSearchResults([]);
        setStationSearchQuery("");
    }, [isOpen, apiKey]);

    const searchStations = useCallback(async (query) => {
        if (!query || query.length < 2) {
            setStationSearchResults([]);
            return;
        }
        let response = await ApiKeysApi.searchStations(query);
        if (response.json) {
            const filtered = response.json.filter(
                (s) => !selectedStations.find((sel) => sel.id === s.id)
            );
            setStationSearchResults(filtered);
        }
    }, [selectedStations]);

    const onSearchChange = (e) => {
        const value = e.target.value;
        setStationSearchQuery(value);
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => searchStations(value), 300);
    };

    const addStation = (station) => {
        setSelectedStations((prev) => [...prev, station]);
        setStationSearchResults((prev) => prev.filter((s) => s.id !== station.id));
        setStationSearchQuery("");
    };

    const removeStation = (stationId) => {
        setSelectedStations((prev) => prev.filter((s) => s.id !== stationId));
    };

    const submitHandle = async (values) => {
        loading.show();
        const payload = {
            name: values.name,
            all_stations: values.all_stations === "1" || values.all_stations === true,
            station_ids: selectedStations.map((s) => s.id),
        };

        let response;
        try {
            if (isEditing) {
                response = await ApiKeysApi.update(apiKey.id, payload);
            } else {
                response = await ApiKeysApi.store(payload);
            }
        } catch (err) {
            toast({
                status: "error",
                title: "Erro ao salvar chave de API!",
                duration: 5000,
                variant: "solid",
                isClosable: true,
            });
            loading.hide();
            return;
        }

        loading.hide();

        if (response.status >= 200 && response.status < 300) {
            let toastConfig = {
                status: "success",
                title: isEditing ? "Chave atualizada com sucesso!" : "Chave criada com sucesso!",
                duration: 5000,
                variant: "solid",
                isClosable: true,
            };

            if (!isEditing && response.json?.token) {
                navigator.clipboard.writeText(response.json.token);
                toastConfig.description = "O token foi copiado para a área de transferência.";
                toastConfig.duration = 8000;
            }

            toast(toastConfig);
            getData();
            onClose();
        } else {
            toast({
                status: "error",
                title: "Erro ao salvar! Cód. " + response.status,
                duration: 3000,
                variant: "solid",
                isClosable: true,
            });
        }
    };

    const initialValues = {
        name: apiKey?.name || "",
        all_stations: apiKey?.all_stations ? "1" : "0",
    };

    const stationLabel = (s) => {
        if (s.description && s.description.trim() !== "") {
            return `${s.description} - ${s.city}/${s.state} (${s.provider})`;
        }
        return `${s.city}/${s.state} (${s.provider})`;
    };

    return (
        <Drawer isOpen={isOpen} onClose={onClose} size="lg">
            <DrawerOverlay backdropFilter="blur(4px)" />
            <DrawerContent bg={drawerBgColor}>
                <DrawerCloseButton />
                <Box bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)" py={4} px={6} mb={4}>
                    <Flex align="center" gap={3}>
                        <Flex align="center" justify="center" bg="whiteAlpha.200" borderRadius="lg" p={2}>
                            <Icon as={FaKey} color="white" boxSize={5} />
                        </Flex>
                        <Text color="white" fontWeight="bold" fontSize="lg">
                            {isEditing ? "Editar" : "Nova"} Chave de API
                        </Text>
                    </Flex>
                </Box>
                <DrawerBody>
                    <Formik onSubmit={submitHandle} initialValues={initialValues} enableReinitialize>
                        {(props) => (
                            <Form id="apiKeyForm">
                                <SimpleGrid columns={12} gap={4}>
                                    <GridItem colSpan={12}>
                                        <Field name="name">
                                            {({ field }) => (
                                                <FormControl isRequired>
                                                    <FormLabel mb="0" fontWeight="normal">Nome:</FormLabel>
                                                    <Input
                                                        {...field}
                                                        borderRadius="10px"
                                                        fontSize="md"
                                                        placeholder="Ex: Integração Sistema X"
                                                    />
                                                </FormControl>
                                            )}
                                        </Field>
                                    </GridItem>

                                    <GridItem colSpan={12}>
                                        <Field name="all_stations">
                                            {({ field }) => (
                                                <FormControl isRequired>
                                                    <FormLabel mb="0" fontWeight="normal">
                                                        Acesso às Estações:
                                                    </FormLabel>
                                                    <Select
                                                        {...field}
                                                        borderRadius="10px"
                                                        fontSize="md"
                                                    >
                                                        <option value="1">Todas as estações</option>
                                                        <option value="0">Estações específicas</option>
                                                    </Select>
                                                </FormControl>
                                            )}
                                        </Field>
                                    </GridItem>

                                    {props.values.all_stations === "0" && (
                                        <GridItem colSpan={12}>
                                            <FormControl>
                                                <FormLabel mb="0" fontWeight="normal">
                                                    Buscar e adicionar estações:
                                                </FormLabel>
                                                <Input
                                                    value={stationSearchQuery}
                                                    onChange={onSearchChange}
                                                    borderRadius="10px"
                                                    fontSize="md"
                                                    placeholder="Pesquise por nome, cidade, provider, identificador..."
                                                    mb={2}
                                                />

                                                {stationSearchResults.length > 0 && (
                                                    <Box
                                                        border="1px solid"
                                                        borderColor={searchBorderColor}
                                                        borderRadius="md"
                                                        maxH="200px"
                                                        overflowY="auto"
                                                        mb={3}
                                                    >
                                                        {stationSearchResults.map((station) => (
                                                            <Flex
                                                                key={station.id}
                                                                p={2}
                                                                cursor="pointer"
                                                                _hover={{ bg: searchHoverBg }}
                                                                onClick={() => addStation(station)}
                                                                align="center"
                                                                justify="space-between"
                                                                borderBottom="1px solid"
                                                                borderColor={searchItemBorder}
                                                            >
                                                                <Text fontSize="sm">
                                                                    {stationLabel(station)}
                                                                </Text>
                                                                <Icon as={FaPlus} color="green.500" boxSize={3} />
                                                            </Flex>
                                                        ))}
                                                    </Box>
                                                )}

                                                {selectedStations.length > 0 && (
                                                    <Box>
                                                        <Text fontSize="xs" color="gray.500" mb={2}>
                                                            {selectedStations.length} estação(ões) selecionada(s):
                                                        </Text>
                                                        <Flex wrap="wrap" gap={2}>
                                                            {selectedStations.map((station) => (
                                                                <Tag
                                                                    key={station.id}
                                                                    size="md"
                                                                    borderRadius="full"
                                                                    variant="solid"
                                                                    colorScheme="green"
                                                                >
                                                                    <TagLabel fontSize="xs">
                                                                        {station.description || `${station.city}/${station.state}`}
                                                                    </TagLabel>
                                                                    <TagCloseButton
                                                                        onClick={() => removeStation(station.id)}
                                                                    />
                                                                </Tag>
                                                            ))}
                                                        </Flex>
                                                    </Box>
                                                )}

                                                {selectedStations.length === 0 && props.values.all_stations === "0" && (
                                                    <Text fontSize="sm" color="orange.500">
                                                        Nenhuma estação selecionada. A chave não terá acesso a nenhuma estação.
                                                    </Text>
                                                )}
                                            </FormControl>
                                        </GridItem>
                                    )}

                                </SimpleGrid>
                            </Form>
                        )}
                    </Formik>
                </DrawerBody>
                <DrawerFooter>
                    <Button variant="outline" mr={3} onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button type="submit" form="apiKeyForm" colorScheme="whatsapp">
                        Salvar
                    </Button>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    );
}

export default ApiKeys;
